import { render } from "./RightSidebarLayout.vue?vue&type=template&id=2395f635"
import script from "./RightSidebarLayout.vue?vue&type=script&lang=js"
export * from "./RightSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/candidate/RightSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2395f635"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2395f635', __exports__)) {
    api.reload('2395f635', __exports__)
  }
  
  module.hot.accept("./RightSidebarLayout.vue?vue&type=template&id=2395f635", () => {
    api.rerender('2395f635', render)
  })

}


export default __exports__